import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

/**
 * Internal-link block pushing the Chicago long-distance cluster.
 * Wording rotates by `seed` so each page uses a different natural anchor.
 */
const HUB = "/long-distance-movers-chicago";

const ROUTES = [
  { to: "/chicago-to-california-movers", label: "Chicago to California" },
  { to: "/chicago-to-dallas-movers", label: "Chicago to Dallas" },
  { to: "/chicago-to-florida-movers", label: "Chicago to Florida" },
  { to: "/chicago-to-arizona-movers", label: "Chicago to Arizona" },
  { to: "/chicago-to-houston-movers", label: "Chicago to Houston" },
  { to: "/chicago-to-colorado-movers", label: "Chicago to Colorado" },
  { to: "/chicago-to-georgia-movers", label: "Chicago to Georgia" },
  { to: "/chicago-to-austin-movers", label: "Chicago to Austin" },
];

const ANCHORS = [
  "our long distance moving team in Chicago",
  "Chicago long distance movers",
  "long-distance moves out of Chicago",
  "our interstate crew based in the Chicago area",
  "moving out of state from Chicagoland",
  "long distance movers serving Chicago",
];

function hash(s: string) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

interface Props {
  seed: string;
  /** Exclude a route (the current page) */
  currentPath?: string;
  variant?: "line" | "box";
  heading?: string;
  showQuote?: boolean;
}

export const LongDistanceLinks = ({ seed, currentPath, variant = "line", heading, showQuote }: Props) => {
  const h = hash(seed);
  const anchor = ANCHORS[h % ANCHORS.length];
  const pool = ROUTES.filter((r) => r.to !== currentPath);
  const start = h % pool.length;
  const picks = [0, 1, 2].map((i) => pool[(start + i) % pool.length]);

  return (
    <section className="container mx-auto px-4 max-w-6xl my-10">
      <div className={variant === "box" ? "rounded-xl border bg-muted/40 p-6" : "border-t pt-6"}>
        <h2 className="text-xl font-bold mb-2 flex items-center gap-2">
          <Truck className="h-5 w-5 text-primary" />
          {heading || "Moving out of state?"}
        </h2>
        <p className="text-muted-foreground">
          See <Link to={HUB} className="text-primary underline font-medium">{anchor}</Link> for guaranteed flat-rate
          quotes to all 48 states. Popular routes:{" "}
          {picks.map((r, i) => (
            <span key={r.to}>
              <Link to={r.to} className="text-primary underline">{r.label}</Link>
              {i < picks.length - 1 ? ", " : "."}
            </span>
          ))}
          {showQuote && (
            <> Ready for a price? <Link to="/quote" className="text-primary underline font-medium">Get your free quote</Link>.</>
          )}
        </p>
      </div>
    </section>
  );
};

export default LongDistanceLinks;
